import React from "react";
import { omit } from "lodash";
import { Select } from "antd";
import { useUsers } from "../../queries/users";

function UserSelect(props) {
  const { data: users = [] } = useUsers();

  return (
    <Select
      placeholder="Select an user"
      showSearch
      filterOption={(input, option) =>
        (option?.searchText ?? "").includes(input.toLowerCase())
      }
      options={users
        .filter((user) => user.active)
        .map((user) => ({
          value: user.id,
          label: `${user.first_name ?? ""} ${user.last_name ?? ""}`,
          searchText: `${user.first_name ?? ""} ${user.last_name ?? ""}`
            .trim()
            .toLowerCase(),
        }))}
      {...omit(props, ["dispatch", "users"])}
    />
  );
}

export default UserSelect;
